<template>
    <div>
      <caption class="caption table-caption">Admin Functions</caption>
      <b-row>
        <b-col offset="3" cols="9" class="d-flex flex-row justify-content-between">
          <b-btn variant="info" @click="loadDealCatalogue" class="mt-1 mb-1">Load Deal Catalogue</b-btn>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import service from '../../services/HttpRequestService';
  import { UserNotifications, withUINotification } from '../../hooks/UserNotifications';
  
  export default {
    props: [],
    data() {
      return {
      };
    },
    methods: {
      async loadDealCatalogue() {
        await withUINotification.bind(this)(async () => {
          await service.loadDealCatalogue();
          UserNotifications.UserChanged(user.Id).emit(this)
        },
        `Failed to load deal catalogue.`,
        `Deal catalogue loaded.`);
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .table-caption {
   display: inline-block;
   width: 100%;
   margin: 10px 0px;
  }
  </style>